module.exports = __webpack_public_path__ + "static/media/kinkhao_01_thumb.2f9fa8d4.png";